export enum FeatureFlagKey {
  ANALYTICS_AND_REPORTING_NAV = 'itl-2046-analytics-reporting-page',
  CPN_FRAUD = 'aic-1232-cpn-validation',
  SALESFORCE_EMBEDDED_MESSAGING = 'itl-2570-salesforce-embedded-messaging',
  ITL_2960_INSPECTOR_PANEL = 'itl-2960-inspector-panel',
  ITL_3258_LIST_CHECKS_TAB = 'itl-3258-list-checks-tab',
  ITL_3152_REPORT_PLATFORM_FEEDBACK = 'itl-3152-report-platform-feedback',
  ITL_3488_NO_MATCH_COMMENT = 'itl-3488-no-match-comment',
  ITL_3287_SPECIALTY_CALCULATION_NOTE = 'itl-3287-specialty-calculation-note',
  // Shared with the settings-service reads cutover (SNAX-1530). Default OFF.
  SNAX_1331_SETTINGS_SERVICE_ENTITY_FEATURES = 'snax-1331-settings-service-entity-features',
  // Gates the Partnerships read-only role on every assignment surface. Default OFF.
  AIC_1285_PARTNER_ADMIN_ROLE = 'aic-1285-partner-admin-role'
}

export enum FeatureFlagProjectName {
  FRAUD_PLATFORM = 'fraud-platform'
}
